import React from 'react'

export default class TravelerSummary extends React.Component {
  render() {
    const { data } = this.props
    // const emailFiltered = data.email.replace(/^[^@]*(@.*)/, '****$1')
    const rawPhone = data.phone.replace(/\D/g, '')
    const phoneFormatted =
      rawPhone.length === 10
        ? rawPhone.replace(/(.{3})(.{3})(.*)/, '($1) $2-$3')
        : rawPhone.length === 11
          ? rawPhone.replace(/(.)(.{3})(.{3})(.*)/, '+$1 ($2) $3-$4')
          : rawPhone

    return (
      <div className="traveler-summary">
        <p className="travelers">
          <span>
            <strong>
              {data.firstName} {data.lastName}
            </strong>{' '}
            <br />
            {data.birthMonth} {data.birthDay}, {data.birthYear}
          </span>
          <span>
            <strong>
              {data.firstNameSpouse} {data.lastNameSpouse}
            </strong>{' '}
            <br />
            {data.birthMonthSpouse} {data.birthDaySpouse},{' '}
            {data.birthYearSpouse}
          </span>
        </p>
        <p>
          {data.email} <br />
          {phoneFormatted} <br />
          {data.address} <br />
          {data.city}
          {data.region ? `, ${data.region}` : ''} {data.zip}
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/traveler-summary.js